<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">{{ rowTitle }}
            <span v-if="row?.isSchedule" class="badge bg-warning ms-2">
              مجدول
            </span>
          </h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/orders">طلبات الصيانة</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">{{ rowTitle }}</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row justify-content-center">
          <div class="col-12 col-sm-10">
            <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
            <mainLoader v-if="mainLoading" />
            <div v-if="row && (row.isSchedule || row.status === 'scheduled')" class="alert alert-warning">
              <div class="date-format"> {{ formatDate(row.scheduleDate) }} : طلب مجدول بتاريخ 🗓️</div>
            </div>
            <div v-if="row && row.isPackageVisit" class="alert alert-success d-flex justify-content-between align-items-center flex-wrap gap-2">
              <div>
                <i class="fa-solid fa-box-open me-2"></i>
                <strong>هذا الطلب مشمول في باقة الصيانة</strong>
                <span class="ms-2">وتم احتسابه كزيارة من الباقة.</span>
              </div>
              <router-link
                v-if="row.subscriptionId"
                :to="`/packagesSubscriptions/update/${row.subscriptionId}`"
                class="alert-link"
              >عرض الاشتراك #{{ row.subscriptionId }}</router-link>
            </div>
            <div v-else-if="row && row.subscriptionId" class="alert alert-info d-flex justify-content-between align-items-center flex-wrap gap-2">
              <div>
                <i class="fa-solid fa-percent me-2"></i>
                تم تطبيق خصم من باقة الصيانة
                <span v-if="row.packageDiscountAmount">بقيمة {{ row.packageDiscountAmount }} ر.س</span>
              </div>
              <router-link :to="`/packagesSubscriptions/update/${row.subscriptionId}`" class="alert-link">
                عرض الاشتراك #{{ row.subscriptionId }}
              </router-link>
            </div>
            <OrdersForm v-if="!mainLoading && checkAccess('maintenance_orders_update')" 
              :cardTitle="rowTitle" 
              :dataRow="row" 
              :orderStatus="orderStatus" 
              :orderCancelAdmin="orderCancelAdmin" 
              :orderTypes="orderTypes" 
              :orderRejectReasons="orderRejectReasons" 
              :orderHoldReasons="orderHoldReasons" 
              :providerAcceptanceStatus="providerAcceptanceStatus" 
              :orderCancelClient="orderCancelClient" 
              :orderCancelProvider="orderCancelProvider" 
              :isSchedule="row?.isSchedule"
              :scheduleDate="row?.scheduleDate"
              @attachments-updated="row = { ...row, ...$event }"
            />
            <OrdersView v-if="!mainLoading && !checkAccess('maintenance_orders_update')" 
              :cardTitle="rowTitle" 
              :dataRow="row" 
              :orderStatus="orderStatus" 
              :orderCancelAdmin="orderCancelAdmin" 
              :orderTypes="orderTypes" 
              :orderRejectReasons="orderRejectReasons" 
              :orderHoldReasons="orderHoldReasons" 
              :providerAcceptanceStatus="providerAcceptanceStatus" 
            />
            <AdminNotesPanel
              v-show="!mainLoading"
              modelName="MaintenanceOrders"
              :recordId="id"
            />
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import { checkAccess, formatDate } from '@/helpers/tools';
import OrdersForm from './form.vue';
import OrdersView from './view.vue';
import AdminNotesPanel from '../admin_notes/adminNotesPanel.vue';

export default {
  name: 'OrdersUpdate',
  components: {
    OrdersForm, OrdersView, AdminNotesPanel
  },
  data(){
    return {
      id: this.$route.params.id,
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      rowTitle: 'تعديل الطلب ',
      row: null,
      orderStatus: {},
      orderCancelAdmin: {},
      orderTypes: {},
      orderRejectReasons: {},
      orderHoldReasons: {},
      providerAcceptanceStatus: {},
      orderCancelClient: {},
      orderCancelProvider: {},
    }
  },
  methods: {
    checkAccess,
    getRowData(){
      this.$http.get(`/api/admin/orders/retrieve/${this.id}`).then(({data}) => {
        this.row = data.row;
        this.rowTitle += `#${data.row.id}`;
        this.orderStatus = data.orderStatus;
        this.orderCancelAdmin = data.orderCancelAdmin;
        this.orderTypes = data.orderTypes;
        this.orderRejectReasons = data.orderRejectReasons;
        this.orderHoldReasons = data.orderHoldReasons;
        this.providerAcceptanceStatus = data.providerAcceptanceStatus;
        this.orderCancelClient = data.orderCancelClient;
        this.orderCancelProvider = data.orderCancelProvider;
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    formatDate,
  },
  created(){
    this.getRowData();
  }
}
</script>
